import { errorNotifier, successNotifier } from "../../..";
import http, { AUTH_ROUTES } from "../../../service/api";

export const updateProfile = async ( payload, setLoading, setRefresh ) => {
  try {
    const result = await http.post(
      AUTH_ROUTES.UPDATE_PROFILE, payload
    );
    setLoading(false);
    setRefresh(true);
    successNotifier("Profile updated successfully");
    return result;
  } catch (e) {
    setLoading(false);
    errorNotifier(e?.response?.data?.message);
  }
};

